import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Switch } from '@cp/ds/src/components/switch';
import { useController } from 'react-hook-form';
import { addDays, format } from 'date-fns';
import { DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT } from '@cp/ds/src/components/form/components/field/dateTimePicker/const';
import { AvailableOnlyFieldProps, FormAvailableOnlyFieldName } from './model';

export const AvailableOnlyField: React.FC<AvailableOnlyFieldProps<any>> = ({
  // careerId,
  form,
  sx,
  // careerDictionary,
  reducedWidth,
}) => {
  const { field } = useController({ name: FormAvailableOnlyFieldName.AvailableOnly, control: form.control });

  const handleChange = React.useCallback(
    (newValue: boolean) => {
      if (newValue) {
        form.setValue(FormAvailableOnlyFieldName.Date, format(addDays(new Date(), 1), DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT));
        form.setValue(FormAvailableOnlyFieldName.Start, null);
        form.setValue(FormAvailableOnlyFieldName.End, null);
      } else {
        form.setValue(FormAvailableOnlyFieldName.Date, null);
        form.setValue(FormAvailableOnlyFieldName.Start, null);
        form.setValue(FormAvailableOnlyFieldName.End, null);
      }

      field.onChange(newValue);
    },
    [field, form],
  );

  return (
    <Box sx={sx}>
      <Switch
        inputName={FormAvailableOnlyFieldName.AvailableOnly}
        label={
          <>
            Показать только{reducedWidth ? <br /> : ' '}доступных{' '}
            {/* {careerDictionary?.[careerId].translation.namePluralGenitive ?? 'специалистов'} */}
          </>
        }
        labelTypography="small text bold"
        onChange={handleChange}
        value={field.value}
      />
    </Box>
  );
};
